export default "__VITE_ASSET__d942e9ef__"